import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { ItemRow } from "@/components/admin/pratica";
import { ADMIN_LABELS, Legend, dotTone } from "@/components/admin/labels";

export const AdminTimeline = ({ oid }) => {
  const [p, setP] = useState(null);
  useEffect(() => { api.get(`/amministrazione/${oid}`).then((r) => setP(r.data)).catch(() => {}); }, [oid]);
  if (!p) return null;
  return (
    <div className="rp-card p-5" data-testid="admin-timeline">
      <div className="flex flex-wrap items-center justify-between gap-3 mb-5">
        <div>
          <p className="rp-label">Timeline amministrativa</p>
          <p className="text-sm text-[#757575] mt-1">{p.client_progress.done} di {p.client_progress.total} voci completate · spunta ogni voce e allega i file direttamente sulla voce (apri la freccia per allegati, date e importi).</p>
        </div>
        <Legend />
      </div>
      <ol className="relative border-l-2 border-[#EBEBEB] ml-3 space-y-4">
        {p.client_items.map((it, i) => {
          const [cls] = dotTone({ ...it, prepared: !!it.prepared_at });
          return (
            <li key={it.key} className="pl-6 relative min-w-0" data-testid={`admin-timeline-step-${it.key}`}>
              <span className={`absolute -left-[9px] top-4 h-4 w-4 rounded-full ring-4 ring-white ${cls}`} />
              <p className="text-[11px] font-mono text-[#757575] mb-1">{String(i + 1).padStart(2, "0")}</p>
              <ItemRow it={{ ...it, label: ADMIN_LABELS[it.key] || it.label }} oid={oid} scope="cliente" staff={p.staff} onSaved={setP} />
            </li>
          );
        })}
      </ol>
    </div>
  );
};
